import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { FormBasic } from 'src/app/models/turns-models/turns-form-basic.model';
import { FormGroup, FormControl } from '@angular/forms';
import { FormsTurnsService } from 'src/app/services/turns-services/forms-turns-service/forms-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-turns-form-user-data-card',
  templateUrl: './turns-form-user-data-card.component.html',
  styleUrls: ['./turns-form-user-data-card.component.scss']
})
export class TurnsFormUserDataCardComponent implements OnInit, OnChanges {

  @Input() form: FormBasic;
  basicDataForm = new FormGroup({
    addName: new FormControl(false),
    addSurname: new FormControl(false),
    addDNI: new FormControl(false),
    addMail: new FormControl(false),
    addTelephone: new FormControl(false),
    addLicensePlate: new FormControl(false),
    addPassport: new FormControl(false),
    addDocument: new FormControl(false),
    addCard: new FormControl(false)
  });
  updateFormuserDataInfoSubscription: Subscription;

  constructor(private formsTurnsService: FormsTurnsService,
    private snackbarService: SnackBarService
  ) { }

  ngOnInit() { }

  ngOnChanges() {
    if (this.form) {
      this.resetForm();
    }
  }

  public submitForm() {
    const validation = this.validateForm();
    if (validation) {
      this.updateFormuserDataInfoSubscription = this.formsTurnsService.updateFormUserDataInfo(this.form.InternalId, this.form.Active, this.basicDataForm.get('addName').value, this.basicDataForm.get('addSurname').value, this.basicDataForm.get('addDNI').value, this.basicDataForm.get('addMail').value, this.basicDataForm.get('addTelephone').value, this.basicDataForm.get('addPassport').value, this.basicDataForm.get('addLicensePlate').value, this.basicDataForm.get('addDocument').value, this.basicDataForm.get('addCard').value).subscribe(
        (res) => {
          this.snackbarService.open('turns-page.snackbar messages.update form success', 'success');
          this.formsTurnsService.refreshForm();
        },
        (error) => {
          this.snackbarService.open(error['error']['message'], 'error');
        }
      );
    } else {
      this.snackbarService.open(validation, 'error');
    }
  }

  public resetForm() {
    this.basicDataForm.patchValue({
      addName: this.form.AddName,
      addSurname: this.form.AddSurname,
      addDNI: this.form.AddDni,
      addMail: this.form.AddMail,
      addTelephone: this.form.AddTelephone,
      addLicensePlate: this.form.AddLicensePlate,
      addPassport: this.form.AddPassport,
      addDocument: this.form.AddDocument,
      addCard: this.form.AddCard
    });
  }

  public validateForm() {
    return true;
  }
}
